import { supabase } from '@/lib/supabase';

export type Lead = {
  firstName: string;
  email: string;
  phone: string;
  createdAt: string;
};

const LS_KEY = 'uq_lead_v1';

export function loadLead(): Lead | null {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<Lead>;
    if (!parsed.firstName || !parsed.email || !parsed.phone) return null;
    return {
      firstName: String(parsed.firstName),
      email: String(parsed.email),
      phone: String(parsed.phone),
      createdAt: String(parsed.createdAt ?? new Date().toISOString()),
    };
  } catch {
    return null;
  }
}

export function saveLeadLocal(lead: Lead): void {
  try {
    localStorage.setItem(LS_KEY, JSON.stringify(lead));
  } catch {
    // ignore quota / private mode
  }
}

/** Persist lead in Supabase when available; never blocks unlock. */
export async function persistLeadRemote(lead: Lead): Promise<void> {
  try {
    if (!supabase) return;
    await supabase.from('leads').insert({
      first_name: lead.firstName,
      email: lead.email,
      phone: lead.phone,
      source: 'kit-configurator',
    });
  } catch (e) {
    console.warn('[lead] remote persist failed', e);
  }
}
